module.exports = __webpack_public_path__ + "img/safari.312ca97c.svg";